// extracted by mini-css-extract-plugin
export default {"checkbox":"HDqXwZN1qGSAwdVa1apJ"};